import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=f2d0a684&scoped=true&"
import script from "./PurchaseModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=f2d0a684&lang=scss&scoped=true&"
import style1 from "./PurchaseModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d0a684",
  null
  
)

export default component.exports